import { render } from "./SapicoPasswordPageFooterCmp.vue?vue&type=template&id=fd63d6aa"
import script from "./SapicoPasswordPageFooterCmp.vue?vue&type=script&lang=js"
export * from "./SapicoPasswordPageFooterCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__